import React, { useState } from 'react';
import { Box, Button, IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import { MoreVert } from '@mui/icons-material';

/**
 * Reusable row-actions cell: an optional primary action (button or icon button)
 * plus a "..." menu for the remaining actions, so admin tables never need
 * horizontal scrolling to reach every row action.
 *
 * primaryAction: { label, icon, onClick, color, disabled, title, iconOnly, variant }
 * menuActions: [{ label, icon, onClick, color, disabled }] (falsy entries are skipped)
 */
const RowActionsMenu = ({ primaryAction, menuActions = [] }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const visibleMenuActions = menuActions.filter(Boolean);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {primaryAction && (
        primaryAction.iconOnly ? (
          <Tooltip title={primaryAction.title || primaryAction.label}>
            {/* span: letiltott gombon is megjelenjen a tooltip */}
            <span>
              <IconButton
                size="small"
                color={primaryAction.color || 'default'}
                disabled={primaryAction.disabled}
                aria-label={primaryAction.title || primaryAction.label}
                onClick={primaryAction.onClick}
              >
                {primaryAction.icon}
              </IconButton>
            </span>
          </Tooltip>
        ) : (
          <Button
            size="small"
            variant={primaryAction.variant || 'outlined'}
            color={primaryAction.color || 'primary'}
            startIcon={primaryAction.icon}
            disabled={primaryAction.disabled}
            onClick={primaryAction.onClick}
          >
            {primaryAction.label}
          </Button>
        )
      )}
      {visibleMenuActions.length > 0 && (
        <>
          <Tooltip title="További műveletek">
            <IconButton size="small" onClick={handleOpen} aria-label="További műveletek">
              <MoreVert fontSize="small" />
            </IconButton>
          </Tooltip>
          <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
            {visibleMenuActions.map((action, index) => (
              <MenuItem
                key={index}
                disabled={action.disabled}
                onClick={() => {
                  handleClose();
                  action.onClick?.();
                }}
                sx={action.color ? { color: `${action.color}.main` } : undefined}
              >
                {action.icon && <ListItemIcon sx={{ minWidth: 32 }}>{action.icon}</ListItemIcon>}
                <ListItemText primary={action.label} />
              </MenuItem>
            ))}
          </Menu>
        </>
      )}
    </Box>
  );
};

export default RowActionsMenu;
